// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"dfa32bf5","434":"f69c4814"}[chunkId] + ".chunk.css";
};